import lectors from "../../../assets/lectors.json";

export default {
  lectors
};
